import { createSyncValidator } from 'app/validators/base'
import invitesValidator from './sync/invites'
import scheduleValidator from './sync/schedule'

const syncValidate = createSyncValidator(
  {
    field: 'users',
    validator: invitesValidator,
  },
  {
    field: 'schedule',
    validator: scheduleValidator,
  }
)

export { syncValidate }
